import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef568a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "h5 mb-1 mt-1" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = {
  key: 0,
  width: "15%"
}
const _hoisted_7 = {
  key: 1,
  width: "5%"
}
const _hoisted_8 = {
  key: 2,
  width: "7%"
}
const _hoisted_9 = { width: "23%" }
const _hoisted_10 = { class: "table table-sm table-borderless" }
const _hoisted_11 = { width: "90%" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = { width: "50%" }
const _hoisted_14 = {
  key: 0,
  class: "table table-sm table-borderless"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { width: "30%" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "30%" }, null, -1))
const _hoisted_18 = { width: "40%" }
const _hoisted_19 = { width: "30%" }
const _hoisted_20 = {
  width: "30%",
  style: {"vertical-align":"middle"}
}
const _hoisted_21 = { width: "40%" }
const _hoisted_22 = {
  key: 1,
  class: "float-right text-danger"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-flag" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, null, -1))
const _hoisted_27 = { key: 0 }

import { computed, inject, ref, provide, PropType } from 'vue';
import { useStore } from 'vuex';
import { Report, Item, Type, Condition, Note, Maintenanceflag } from '@/models';
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";

import Photos from '@/components/photo/Photos.vue';

import ConditionResponsibilities from "@/components/depository/ConditionResponsibilities.vue";
import Deductions from "@/components/depository/Deductions.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Item',
  props: {
  index: { type: Number as PropType<number> },
  item: { type: Item, required: true },
},
  setup(__props) {

const actProperty: any = inject('actProperty');

const props = __props;

const roomIndex = inject<number>('roomIndex');
const sectionIndex = inject<number>('sectionIndex');
const typeIndex = inject<number>('typeIndex');
const typeName = inject<string>('typeName');
const store = useStore();

provide('itemIndex', props.index);

const report = computed(() => store.state.reports.current);
const item = computed(() => props.item);
const itemNumber = computed(() => store.getters['reports/itemNumber'](item.value));
const showPhotos = ref(true);

const isCheckOut = () => {
  return report.value.type == "checkout";
};

const hasResponsibilities = (item: Item): boolean => {
  return item.condition.out.notes.some(
    (note: Note) => false === _isEmpty(note.responsibility)
  );
};

const getItemPath = (append: string) => {
  if (append) {
    append = `.${append}`;
  }
  return `rooms[${roomIndex}].sections[${sectionIndex}].types[${typeIndex}].items[${props.index}]${append}`;
};

const getInPhotos = (item: Item) => {
  return _get(item, "condition.in.photos", []);
};

const getOutPhotos = (item: Item) => {
  return _get(item, "condition.out.photos", []);
};

const isSameAsCheckIn = (): boolean => {
  return _get(item.value, "condition.out.sameAsCheckin.active", false);
};

const getSaciNote = (): string => {
  return _get(
    item.value,
    "condition.out.sameAsCheckin.note.note",
    "Same as Check-In"
  );
};

const getConditionInNotes = () => {
  const notes = _get(item.value, "condition.in.notes", false);
  if (notes === false) {
    return [];
  }
  return notes;
};

const getConditionOutNotes = () => {
  let notes = _get(item.value, "condition.out.notes", false);
  if (notes === false) {
    return [];
  }
  notes = notes.filter((note: Note) => {
    return note?.responsibility?.filter(
      (responsibility: string) => responsibility
    );
  });
  return notes;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card bg-white",
    id: `item-${props.item._uuid}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(itemNumber.value) + ". " + _toDisplayString(_unref(typeName)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (
                !_unref(actProperty).isFactoryreport(report.value.type) || props.item.locallyadded
              )
              ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(props.item.name), 1)
                ]))
              : _createCommentVNode("", true),
            (!_unref(actProperty).isFactoryreport(report.value.type))
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(props.item.qty), 1)
                ]))
              : _createCommentVNode("", true),
            (!_unref(actProperty).isFactoryreport(report.value.type))
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                  _createElementVNode("div", null, _toDisplayString(props.item.colour), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getConditionInNotes(), (note) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: note._uuid
                  }, [
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("div", null, _toDisplayString(note.note), 1)
                    ]),
                    _hoisted_12
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("td", _hoisted_13, [
              (isCheckOut())
                ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                    _createElementVNode("tbody", null, [
                      (isSameAsCheckIn())
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                            _createElementVNode("td", _hoisted_16, [
                              _createElementVNode("div", null, _toDisplayString(getSaciNote()), 1)
                            ]),
                            _hoisted_17,
                            _createElementVNode("td", _hoisted_18, [
                              _createVNode(ConditionResponsibilities, {
                                "note-path": 
                          getItemPath('condition.out.sameAsCheckin.note')
                        
                              }, null, 8, ["note-path"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getConditionOutNotes(), (note, $noteIndex) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: note._uuid
                        }, [
                          _createElementVNode("td", _hoisted_19, [
                            _createElementVNode("div", null, _toDisplayString(note.note), 1)
                          ]),
                          _createElementVNode("td", _hoisted_20, [
                            _createVNode(Deductions, {
                              item: item.value,
                              note: note,
                              noteIndex: $noteIndex
                            }, null, 8, ["item", "note", "noteIndex"])
                          ]),
                          _createElementVNode("td", _hoisted_21, [
                            _createVNode(ConditionResponsibilities, {
                              "note-path": 
                          getItemPath(`condition.out.notes[${$noteIndex}]`)
                        
                            }, null, 8, ["note-path"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  isCheckOut() && report.value.flagged && hasResponsibilities(props.item)
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                : _createCommentVNode("", true)
            ])
          ]),
          (isCheckOut() && showPhotos.value)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("td", null, [
                  (_openBlock(), _createBlock(Photos, {
                    key: `item${props.item._uuid}in${props.item.condition.in.photos.length}`,
                    photos: getInPhotos(props.item),
                    path: getItemPath('condition.in.photos'),
                    shownewbutton: false,
                    showrotatebutton: false,
                    showdeletebutton: false
                  }, null, 8, ["photos", "path"]))
                ]),
                _createElementVNode("td", null, [
                  (isCheckOut())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (_openBlock(), _createBlock(Photos, {
                          key: `item${props.item._uuid}out${props.item.condition.out.photos.length}`,
                          photos: getOutPhotos(props.item),
                          path: getItemPath('condition.out.photos'),
                          shownewbutton: false,
                          showrotatebutton: false,
                          showdeletebutton: false
                        }, null, 8, ["photos", "path"]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})